import * as z from "zod";

export const createImageBodySchema = z
  .object({
    id: z.number(),
  })
  .nonstrict();
